import type { PropsWithChildren } from 'react';

import { cn } from '@/shared/helpers';

type DetailGroupProps = PropsWithChildren<{
  className?: string;
  constrainLabels?: boolean;
}>;

export function DetailGroup({ className, children, constrainLabels }: DetailGroupProps) {
  return (
    <div
      data-slot="detail-group"
      className={cn(
        'grid min-w-0 text-sm',
        constrainLabels
          ? 'grid-cols-[fit-content(--spacing(36))_minmax(0,1fr)]'
          : 'grid-cols-[max-content_minmax(0,1fr)]',
        className,
      )}
    >
      {children}
    </div>
  );
}
